import {inject} from '@vue/composition-api'

export default function useTranslations () {
  const translations = inject('translations')
  const currentLanguage = inject('currentLanguage').value

  return function t (key) {
    return translations[currentLanguage][key]
  }
}
